<template>
	<div> <!-- Essa div só existe para envolver o modal tbm -->

		<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

			<div v-if="!$store.state.cadastro_parte_visivel">

				<h1>Peticionamento Eletrônico ({{ passoAtual }} de {{ totalPassos }}) - {{ titulo_pagina }}</h1>

				<!-- div dos passos -->
				<div>
					<span :style="{ 'font-weight': passoAtual === 1 ? 'bold' : 'normal' }">Informações do processo</span>&nbsp;>>>&nbsp;
					<span :style="{ 'font-weight': passoAtual === 2 ? 'bold' : 'normal' }">Assuntos</span>&nbsp;>>>&nbsp;
					<span :style="{ 'font-weight': passoAtual === 3 ? 'bold' : 'normal' }">Partes Autoras</span>&nbsp;>>>&nbsp;
					<span :style="{ 'font-weight': passoAtual === 4 ? 'bold' : 'normal' }">Partes Rés</span>&nbsp;>>>&nbsp;
					<span :style="{ 'font-weight': passoAtual === 5 ? 'bold' : 'normal' }">Documentos</span>
				</div>

				<!-- BOTÕES PARA AVANÇAR E VOLTAR PASSOS -->
				<div style="text-align: right; width: 100%;" class="mb-5">
					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 200px; cursor: pointer;" @click="RetornarEtapaInicial()" v-if="passoAtual == 5">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Retornar para Etapa inicial</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer;" @click="passoAnterior()" v-if="passoAtual > 1">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Anterior</label>
					</button>
					<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="proximoPasso()">
						<label style="color: white; vertical-align: middle; cursor: pointer;"> {{ (passoAtual == 5 ? "Finalizar" : "Próxima >") }}</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 220px; cursor: pointer;" @click="SalvarDistribuicaoFutura()" v-if="passoAtual == 5">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Salvar para Distribuição Futura</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click="Cancelar()">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>C</u>ancelar</label>
					</button>
				</div>
				<!-- FIM DOS BOTÕES PARA AVANÇAR E VOLTAR PASSOS -->

				<div class="row mb-3" style="width: 100%;" v-if="passoAtual === 1"> <!-- Toggle de IA somente visual do simulador. Não tem funcionalidade ainda. -->
					<div class="col-12 d-flex align-items-center">
						<button class="toggle-switch" :class="{ 'toggle-switch--on': modelValue }" type="button" role="switch" :aria-checked="modelValue" @click="toggle">
							<span class="toggle-switch__track">
								<span class="toggle-switch__thumb"></span>
							</span>
						</button>

						<!-- Texto ao lado -->
						<span style="font-size: 14px;">
							&nbsp;&nbsp;Apoio por Inteligência Artificial
							<span class="material-icons" style="font-size: 16px; vertical-align: middle; cursor: pointer;">
								help
							</span>
						</span>
					</div>
				</div>

				<!-- PASSO 1 - INFORMAÇÕES PRELIMINARES DO PROCESSO -->
				<div class="form-container mb-3" v-if="passoAtual === 1">
					<div class="form-title">Informações Preliminares</div>

					<div class="row">
						<div class="col-4">
							<div class="form-group">
								<label for="cidade" class="mt-1"><strong>Desejo entrar com a ação em:</strong></label>
								<select class="form-control custom-select-sm custom-dropdown" v-model="cidade_selecionada">
									<option v-for="cidade in cidades" :key="cidade" :value="cidade.id">{{ cidade.descricao }}</option>
								</select>
								<label for="rito" class="mt-1"><strong>Rito:</strong></label>
								<select class="form-control custom-select-sm custom-dropdown" v-model="rito_selecionado">
									<option v-for="rito in ritos" :key="rito.id" :value="rito.id">{{ rito.descricao }}</option>
								</select>
								<label for="area" class="mt-1"><strong>Área:</strong></label>
								<select class="form-control custom-select-sm custom-dropdown" v-model="area_selecionada">
									<option disabled selected>-- Selecione uma área --</option>
									<option v-for="area in areas" :key="area.id" :value="area.id">{{ area.descricao }}</option>
								</select>
								<label for="classe_processual" class="mt-1"><strong>Classe processual:</strong></label>
								<select class="form-control custom-select-sm custom-dropdown" v-model="classe_processual_selecionada">
									<option v-for="classe in classes_processuais" :key="classe.id" :value="classe">{{ classe.descricao }}</option>
								</select>
								<label for="nivel_sigilo" class="mt-1"><strong>Nível de Sigilo do Processo:</strong>&nbsp;
									<span class="material-icons" style="font-size: small; color: lightgray;" title="">help</span>
								</label>
								<select class="form-control custom-select-sm custom-dropdown" v-model="nivel_sigilo_selecionado">
									<option :value="''" disabled>Selecione o sigilo</option>
									<option :value="0">Sem Sigilo (Nível 0)</option>
									<option :value="1">Com Sigilo (Nível 1)</option>
								</select>
							</div>

							<div class="form-group mt-2" v-if="classe_processual_selecionada != ''">
								<label for="nivel_sigilo">Processo Originário:</label>
								<input type="text" class="form-control" v-model="processo_originario">

								<label for="nivel_sigilo">Juízo:</label>
								<input type="text" class="form-control" v-model="juizo" disabled>
							</div>

						</div>
						<div class="col-4">
							<div class="form-group">
								<label for="valor_causa" class="mt-1"><strong>Valor da Causa: (R$)</strong></label>
								<span style="font-size: small; font-weight: bold;">&nbsp;(Somente números)</span>
								<input type="text" class="form-control" v-model="valor_causa" @input="formatarValorMonetario">
								<span style="font-size: small; font-weight: bold;" v-if="valor_causa != 0">Previsão de Custas:&nbsp;</span>
								<label for="previsao_custas" class="mt-1" v-if="valor_causa != 0">{{ previsao_custas }}</label>
								<br />
								<input type="checkbox" v-model="valor_causa_nao_se_aplica">&nbsp;Não se aplica&nbsp;&nbsp;&nbsp;
								<input type="checkbox" v-model="valor_alcada">&nbsp;Valor de Alçada
							</div>
							<div class="form-group">
								<br />
								<a href="#" style="text-decoration: none; color: blue; font-size: small;" @click="IncluirOutros();">+ Incluir outros advogados</a>
							</div>
							<div class="form-group mt-3 form-container" v-if="incluir_outros_advogados">
								<label for="login_outros_advogados" class="mt-1"><strong>Login:</strong></label>
								<input type="text" class="form-control" v-model="login_outro_usuario" @input="buscarUsuarios">
								<ul v-if="usuarios_pesquisados.length" class="list-group">
									<li v-for="usuario in usuarios_pesquisados" :key="usuario.id" class="list-group-item" @click="selecionarUsuario(usuario)" style="cursor: pointer;">
										{{ usuario.name }}
									</li>
								</ul>
								<button type="button" class="btn btn-sm btn-light mt-2" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white; border: 0.5px solid gray; width: 80px; height: 30px;">
									<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Incluir</label>
								</button>

								<div id="collapse2" class="collapse show">
									<div class="card-body">
										<p style="font-size: small; text-align: right;">Lista de Usuários ({{ login_outros_usuarios.length }} registros):</p>
										<table class="table table-striped table-bordered mt-2 border">
											<thead>
												<tr class="text-center">
													<th scope="col" style="background-color: lightgrey; display: none;">id</th>
													<th scope="col" style="background-color: lightgrey; width: 70%;">Usuário</th>
													<th scope="col" style="background-color: lightgrey; width: 30%;">Ações</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="usuario in login_outros_usuarios">
													<td style="display: none;">{{ usuario.id }}</td>
													<td style="text-align: left;">{{ usuario.name }}</td>
													<td style="text-align: center;">
														<button @click="excluirItem(usuario.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;">
															<span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>

							</div>
						</div>
						<div class="col-4"></div>

						<div class="col-12 mt-3" v-if="classe_processual_selecionada != ''">
							<div class="alert alert-warning" role="alert">
								Para acionar o plantão é necessário telefonar. Verifique se a situação se enquadra na norma bem como nos telefones de contato, <a href="#" style="text-decoration: none; color: blue; font-weight: bold;">clicando aqui</a>.
							</div>
						</div>
					</div>
				</div>
				<!-- FIM PASSO 1 - INFORMAÇÕES PRELIMINARES DO PROCESSO -->

				<!-- PASSO 2 - ASSUNTOS DO PROCESSO -->
				<div v-if="passoAtual === 2">
					<processo-assunto-component></processo-assunto-component>
				</div>
				<!-- FIM PASSO 2 - ASSUNTOS DO PROCESSO -->

				<!-- PASSO 3 - PARTES DO PROCESSO -->
				<div v-if="passoAtual === 3"> <!-- Partes Autoras (Polo Ativo) -->
					<processo-partes-component :polo="1"></processo-partes-component>
				</div>
				<div v-if="passoAtual === 4"> <!-- Partes Rés (Polo Passivo) -->
					<processo-partes-component :polo="2"></processo-partes-component>
				</div>
				<!-- FIM PASSO 4 - PARTES DO PROCESSO -->

				<!-- FIM PASSO 4 - DOCUMENTOS DO PROCESSO -->
				<div v-if="passoAtual === 5">
					<processo-documentos-component ref="documentosComponente"></processo-documentos-component>
				</div>

				<!-- #region AI HTML -->

				<!-- #region caixa de análise da IA -->
				<div v-if="funcionalidade_IA_ativa == true && passoAtual == 5" class="ia-container">
					<hr class="ia-divider" />
					<!-- mensagem de erro quando houver algum problema com a IA -->
					<div v-if="exibirMensagemErro == true" class="ia-error-message">
						<div>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
								<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
								<path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
							</svg>
							<p id="mensagem-retorno">{{ mensagemRetornoIA }}</p>
						</div>
						<span class="ia-modal-close" @click="fecharMensagemErro">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
								<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
							</svg>
						</span>
					</div>

					<div class="ia-content-wrapper">
						<div class="ia-left-section">
							<div>
								<h1 class="ia-title">
									Análise da petição com Inteligência Artificial
								</h1>
								<h2 class="ia-subtitle">
									Ferramenta pedagógica exclusiva do TWM Simuladores.
								</h2>
								<button class="ia-button" type="button" @click="AnalisarComIA()" :disabled="botao_analisarIA_desabilitado">
									<span v-if="botao_analisarIA_desabilitado">
										<span class="ia-spinner"></span> Gerando com
										IA...
									</span>
									<span v-else>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
											<path fill-rule="evenodd" stroke="currentColor" stroke-width="2" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
										</svg>
										<span>Analisar petição com IA</span>
									</span>
								</button>

								<!-- Botão para verificar as sugestões somente se as sugestões já estiverem carregadas -->
								<button class="ia-button-result" type="button" v-if="exibirBotaoSugestao" @click="abrirModalIA">
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
										<path fill-rule="evenodd" stroke="currentColor" stroke-width="2" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
									</svg>
									<span>Verificar Sugestão(ões)</span>
								</button>
							</div>
							<div class="ia-image-container">
								<img class="ia-image" :src="BASE_URL + 'imagens/personagem.png'" alt="Personagem" />
							</div>
						</div>
						<!-- end div -->
						<div class="ia-right-section">
							<h1 class="ia-title">Como usar?</h1>
							<ol class="ia-list">
								<li>Efetue sua petição normalmente.</li>
								<li>
									Antes de salvar, clique em "Analisar Petição com
									IA".
								</li>
								<li>Receba sugestões de melhoria.</li>
								<li>Avalie se as sugestões são viáveis.</li>
								<li>
									Nenhuma alteração será feita automaticamente no
									documento original.
								</li>
							</ol>
						</div>
					</div>
				</div>
				<!-- #endregion -->

				<!-- Modal da Sugestão da IA -->
				<div v-if="mostrarModal_IA" class="ia-modal">
					<div class="ia-modal-content">
						<span class="ia-modal-close" @click="fecharModalIA">&times;</span>

						<!-- header -->
						<div class="suggestions-header">
							<!-- conteudo -->
							<div class="suggestions-header-content">
								<h2 class="suggestions-header-title">
									<svg class="suggestions-header-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
										<path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1" />
									</svg>
									<span>Sugestões da nossa IA</span>
								</h2>
								<hr class="suggestions-divider" />
								<!-- Mensagem explicativa -->
								<p class="suggestions-header-info">
									As sugestões apresentadas a seguir foram geradas
									pela nossa Inteligência Artificial avançada, que
									utiliza aprendizado contínuo para oferecer as
									melhores recomendações possíveis. Estas sugestões
									são baseadas em análises de dados e têm como
									objetivo melhorar a eficiência e a qualidade de seu
									trabalho.
								</p>
							</div>
							<!-- personagem -->
							<div class="suggestions-header-robot">
								<img class="ia-image" :src="BASE_URL + 'imagens/personagem.png'" alt="Personagem" />
							</div>
						</div>

						<!-- Layout flexível para o menu lateral e o corpo da sugestão -->
						<div class="suggestions-layout">
							<!-- Menu lateral com horários das sugestões -->
							<div class="suggestions-menu">
								<p class="suggestions-menu-title">
									Histórico de Pesquisa
								</p>
								<ul style="list-style: none; display: none;">
									<li v-for="(sugestao, index) in sugestoesIA" :key="index" @click="mostrarSugestao(index)" :class="{
										'selected-suggestion':
											sugestaoSelecionada === sugestao,
									}">
										Sugestão recebida em
										{{ formatDate(sugestao.created_at) }}
									</li>
								</ul>
							</div>

							<!-- Corpo para exibir a sugestão selecionada -->
							<div class="suggestions-content">
								<h3>Conteúdo da Análise</h3>
								<template v-if="sugestaoSelecionada">
									<div v-html="sugestaoSelecionada.resposta_recebida"></div>
								</template>
								<template v-else>
									<div class="suggestions-loading-container">
										<div class="suggestions-spinner-border" role="status">
											<span class="sr-only">Carregando...</span>
										</div>
										<span class="suggestions-loading-text">Gerando sugestões, por favor
											aguarde...</span>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<!-- #endregion AI HTML -->

				<!-- FIM PASSO 5 - DOCUMENTOS DO PROCESSO -->

				<!-- BOTÕES PARA AVANÇAR E VOLTAR PASSOS DO FINAL DA TELA -->
				<div style="text-align: right; width: 100%;" class="mb-5">
					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 200px; cursor: pointer;" @click="RetornarEtapaInicial()" v-if="passoAtual == 5">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Retornar para Etapa inicial</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer;" @click="passoAnterior()" v-if="passoAtual > 1">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Anterior</label>
					</button>
					<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 90px; cursor: pointer; background-color: #007BFF;" @click="proximoPasso()">
						<label style="color: white; vertical-align: middle; cursor: pointer;"> {{ (passoAtual == 5 ? "Finalizar" : "Próxima >") }}</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 220px; cursor: pointer;" @click="SalvarDistribuicaoFutura()" v-if="passoAtual == 5">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Salvar para Distribuição Futura</label>
					</button>

					<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click="Cancelar()">
						<label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>C</u>ancelar</label>
					</button>
				</div>
				<!-- FIM DOS BOTÕES PARA AVANÇAR E VOLTAR PASSOS DO FINAL DA TELA -->


			</div>
			<div v-if="$store.state.cadastro_parte_visivel">
				<!-- Cadastrar pessoa. -->
				<processo-parte-cadastrar></processo-parte-cadastrar>
			</div>


		</div>
		<div v-if="showModal" class="modal-backdrop fade show"></div>
		<div v-if="showModal" class="modal" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog modal-largura-customizada" role="document"> <!-- Classe customizada adicionada aqui -->
				<div class="modal-content" style=" background-color: #F8F8F8;">

					<processo-resumo-modal></processo-resumo-modal>

					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; width: 90px; cursor: pointer; background-color: white;" @click="showModal = false">
							<label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Fechar</label>
						</button>
						<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; cursor: pointer; background-color: #007BFF;" @click="GravarProcesso()">
							<label style="color: white; vertical-align: middle; cursor: pointer;">{{ texto_btn_finalizar_processo }}</label>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div> <!-- Essa div só existe para envolver o modal tbm -->
</template>

<script>
	function normalizaTexto(texto) {
		return texto
			.normalize("NFD")                    // separa acentos
			.replace(/[\u0300-\u036f]/g, "")     // remove acentos
			.replace(/ç/gi, "c")                 // converte ç para c
			.trim()
			.toUpperCase();
	}

	export default {
		name: "ProcessoComponent",
		props: {
			user: {
				type: Object,
				required: true,
			},
		},
		computed: {
			userInfo: () => window.Laravel.userInfo, // validar se precisa disso
		},
		data() {
			return {
				selectedFile: null,
				BASE_URL: window.Laravel.baseUrl,

				titulo_pagina: 'Informações do processo',
				passoAtual: 1,
				totalPassos: 5,
				processo: {},

				cidade_selecionada: '',
				cidades: [],
				rito_selecionado: '',
				ritos: [],
				area_selecionada: '',
				areas: [],
				classe_processual_selecionada: '',
				classes_processuais: [],
				nivel_sigilo_selecionado: '',

				processo_originario: '',
				valor_causa: '',
				previsao_custas: 0,
				valor_causa_nao_se_aplica: false,
				valor_alcada: false,
				juizo: '',
				incluir_outros_advogados: false,
				login_outro_usuario: '',
				login_outros_usuarios: [],
				usuarios_pesquisados: [],

				showModal: false,
				texto_btn_finalizar_processo: 'Finalizar',

				modelValue: false,

				// #region AI Variables
				mostrarModal_IA: false,
				exibirBotaoSugestao: false,
				botao_analisarIA_desabilitado: false,
				exibirMensagemErro: false,
				mensagemRetornoIA: "",
				mensagemErroTimeout: null,
				funcionalidade_IA_ativa: false,
				funcionalidade_IA_apenas_admin_ativa: false,
				sugestoesIA: [],
				sugestaoSelecionada: null,
				// #endregion
			};
		},
		methods: {

			// #region AI methods
			abrirModalIA() {
				this.mostrarModal_IA = true;
			},
			fecharMensagemErro() {
				this.exibirMensagemErro = false;
			},
			mostrarAlertaErro(mensagem) {
				this.mensagemRetornoIA = mensagem;
				this.exibirMensagemErro = true;

				if (this.mensagemErroTimeout) {
					clearTimeout(this.mensagemErroTimeout);
				}

				this.mensagemErroTimeout = setTimeout(() => {
					this.exibirMensagemErro = false;
					this.mensagemErroTimeout = null;
				}, 5000);

				alert(mensagem);
			},
			fecharModalIA() {
				this.mostrarModal_IA = false;
			},
			formatDate(dateString) {
				const options = {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
					hour: "2-digit",
					minute: "2-digit",
				};
				return new Date(dateString).toLocaleDateString("pt-BR", options);
			},
			formatText(texto_formatar) {
				// Converte markdown-like para HTML básico
				return texto_formatar
					.replace(/^### (.*$)/gim, "<h4>$1</h4>")
					.replace(/^\s*\n\* (.*)/gim, "<ul>\n<li>$1</li>\n</ul>")
					.replace(/^\* (.*)/gim, "<li>$1</li>")
					.replace(/^\s*\n\d\. (.*)/gim, "<ul>\n<li>$1</li>\n</ul>")
					.replace(/\*\*(.*)\*\*/gim, "<strong>$1</strong>")
					.replace(/\n$/gim, "<br /><br />");
			},
			ConfigurarIA() {
				if (this.funcionalidade_IA_apenas_admin_ativa === false) {
					this.funcionalidade_IA_ativa =
						typeof window.Laravel !== "undefined" ?
							window.Laravel.ATIVAR_FUNCIONALIDADE_IA :
							false;
				} else {
					if (this.user && this.user.isAdmin == 1) {
						this.funcionalidade_IA_ativa =
							typeof window.Laravel !== "undefined" ?
								window.Laravel.ATIVAR_FUNCIONALIDADE_IA :
								true;
					}
				}
			},
			mostrarSugestao(index) {
				this.sugestaoSelecionada = this.sugestoesIA[index];
			},
			BuscarSugestoesIA() {
				let processoId =
					this.$store && this.$store.state.processoId ?
						this.$store.state.processoId :
						0;
				let peticaoId =
					this.$store && this.$store.state.peticaoId ?
						this.$store.state.peticaoId :
						0;

				axios
					.get(
						`${this.BASE_URL}sugestoes_ia_buscar/${processoId}/peticaoid/${peticaoId}`
					)
					.then((res) => {
						if (res.data && res.data.sugestoes) {
							this.sugestoesIA = res.data.sugestoes.map(
								(sugestao) => {
									let respostaCompleta =
										sugestao.resposta_recebida;
									let indexStart =
										respostaCompleta.indexOf("``html");
									if (indexStart !== -1) {
										respostaCompleta =
											respostaCompleta.substring(indexStart);
									}
									respostaCompleta = respostaCompleta
										.replace(/`html/g, "")
										.replace(/`/g, "")
										.trim();

									return {
										created_at: sugestao.created_at,
										resposta_recebida: respostaCompleta,
										modelo: sugestao.modelo,
										conteudo_enviado: sugestao.conteudo_enviado,
										data_resposta: sugestao.data_resposta,
									};
								}
							);
						}
					})
					.catch((error) => {
						console.error("Erro ao buscar sugestões da IA:", error);
					});
			},
			AnalisarComIA() {
				this.sugestaoSelecionada = null;

				let dadosDoFilho = { conteudo_editor: "", uploadedFiles: [] };

				if (this.$refs.documentosComponente) {
					dadosDoFilho = this.$refs.documentosComponente.retornaDadosParaIA();
				}
				else {
					console.error("Não foi possível recuperar os documentos para análise.");
				}

				let conteudo_editor = dadosDoFilho.conteudo_editor;
				const uploadedFiles = dadosDoFilho.uploadedFiles;

				let tem_arquivos = uploadedFiles.length > 0;
				let tem_texto = conteudo_editor !== "" && conteudo_editor !== "<p></p>" && conteudo_editor !== null;

				if (!tem_texto && !tem_arquivos) {
					this.mostrarAlertaErro(
						"Para analisar, é necessário digitar algo no editor ou anexar um arquivo de petição."
					);
					return;
				}

				let payload = {
					conteudo_editor: conteudo_editor,
					uploadedFiles: uploadedFiles,
					userId: this.user ? this.user.id : null,
					peticaoId: this.$store && this.$store.state.peticaoId ?
						this.$store.state.peticaoId : null,
					processoId: this.$store && this.$store.state.processoId ?
						this.$store.state.processoId : null,
				};

				this.botao_analisarIA_desabilitado = true;

				axios
					.post(`${this.BASE_URL}analisar_chatgpt`, payload)
					.then((res) => {
						if (
							res.data &&
							Array.isArray(res.data.choices) &&
							res.data.choices.length > 0
						) {
							let respostaCompleta =
								res.data.choices[0].message.content;
							respostaCompleta = respostaCompleta
								.replace(/```html/g, "")
								.replace(/```/g, "")
								.trim();
							this.botao_analisarIA_desabilitado = false;

							const novaSugestao = {
								created_at: new Date().toISOString(),
								resposta_recebida: respostaCompleta,
							};

							this.sugestaoSelecionada = novaSugestao;
							this.exibirBotaoSugestao = true;
							this.abrirModalIA();
							this.BuscarSugestoesIA();
						} else {
							this.botao_analisarIA_desabilitado = false;
							this.mostrarAlertaErro(
								"A IA não retornou uma análise válida."
							);
						}
					})
					.catch((error) => {
						console.error(error);
						let msg = "Ocorreu um erro inesperado.";
						if (
							error.response &&
							error.response.data &&
							error.response.data.error
						) {
							msg = error.response.data.error;
						}
						this.mostrarAlertaErro(msg);
						this.botao_analisarIA_desabilitado = false;
					});
			},
			// #endregion
			toggle() {
				this.modelValue = !this.modelValue;
			},
			proximoPasso() {
				if (this.passoAtual == 1) { //Solicitado para ir para o passo 2, então tem que verificar as informações até o momento e gravar o processo.

					//Validacoes passo 1
					if (this.cidade_selecionada == '') {
						alert("Selecione a cidade");
						return;
					}

					if (this.rito_selecionado == '') {
						alert("Selecione o rito");
						return;
					}

					if (this.area_selecionada == '') {
						alert("Selecione a área");
						return;
					}

					if (this.classe_processual_selecionada == '') {
						alert("Selecione a Classe Processual");
						return;
					}

					if (this.valor_causa == '') {
						alert("O campo valor da causa não foi preenchido.");
						return;
					}


					const dados_gravar = {
						cidade_selecionada: this.cidade_selecionada,
						rito_selecionado: this.rito_selecionado,
						area_selecionada: this.area_selecionada,
						classe_processual_selecionada: this.classe_processual_selecionada.id,
						nivel_sigilo_selecionado: this.nivel_sigilo_selecionado,
						processo_originario: this.processo_originario,
						valor_causa: this.valor_causa,
						valor_causa_nao_se_aplica: this.valor_causa_nao_se_aplica,
						previsao_custas: this.previsao_custas,
						valor_alcada: this.valor_alcada,
						juizo: this.juizo,
						login_outros_usuarios: this.login_outros_usuarios,

						processo: this.processo, //Envia o processo também para verificar no backend se o já tem id criado.
					};

					axios.post(this.BASE_URL + 'cadastrar/processo', dados_gravar)
						.then(response => {
							if (response.status === 200) {
								this.processo = response.data; //Atualiza a variável processo deste componente
								this.$store.commit('setProcesso', this.processo); //Atualiza a variável processo do store.js (global)
							}
							else {
								alert('Erro ao gravar dados.');
							}
						})
						.catch(error => {
							alert('Erro ao gravar dados: ' + error);
							console.error(error);
						});
				}
				else if (this.passoAtual == 2) { /* Passo 2 funciona certinho no componente dele. Não precisa adicionar nada aqui. */

					//VALIDAÇÃO COMENTADA APENAS PARA AGILIZAR O PROCESSO DE TESTE DA PRÓXIMA TELA. DESCOMENTAR DEPOIS
					if (!Array.isArray(this.$store.state.processo.assuntos) || this.$store.state.processo.assuntos.length <= 0) {
						alert("Nenhum assunto selecionado.");
						return;
					}



				}
				else if (this.passoAtual == 3) { /* Partes do processo - Autores (polo ativo) */


					//VALIDAÇÃO COMENTADA APENAS PARA AGILIZAR O PROCESSO DE TESTE DA PRÓXIMA TELA. DESCOMENTAR DEPOIS
					if (!Array.isArray(this.$store.state.processo.polo_ativo) || this.$store.state.processo.polo_ativo.length <= 0) {
						alert("Está faltando uma parte autora.");
						return;
					}
				}
				else if (this.passoAtual == 4) { /* Partes do processo - Réus (polo passivo) */
					//VALIDAÇÃO COMENTADA APENAS PARA AGILIZAR O PROCESSO DE TESTE DA PRÓXIMA TELA. DESCOMENTAR DEPOIS
					const descricoesIgnoradas = [
						"DIVÓRCIO CONSENSUAL",
						"OUTRA AQUI"
					].map(normalizaTexto);

					const descricaoSelecionada = normalizaTexto(this.classe_processual_selecionada?.descricao?.toUpperCase() || "");


					if (
						!descricoesIgnoradas.includes(descricaoSelecionada) &&
						(!Array.isArray(this.$store.state.processo.polo_passivo) ||
							this.$store.state.processo.polo_passivo.length <= 0)
					) {
						alert("Está faltando uma parte réu.");
						return;
					}
				}
				else if (this.passoAtual == 5) {
					//Colocar validações aqui.
					this.FinalizarDocumento();
				}


				if (this.passoAtual <= 4) this.passoAtual++;

				if (this.passoAtual == 1) { this.titulo_pagina = "Informações do processo"; }
				if (this.passoAtual == 2) { this.titulo_pagina = "Assuntos"; }
				if (this.passoAtual == 3) { this.titulo_pagina = "Partes (autores)"; }
				if (this.passoAtual == 4) { this.titulo_pagina = "Partes ( Réus )"; }
				if (this.passoAtual == 5) { this.titulo_pagina = "Documentos"; }
			},
			passoAnterior() {
				if (this.passoAtual > 1) this.passoAtual--;
			},
			RetornarEtapaInicial() {
				this.passoAtual = 1;
			},
			SalvarDistribuicaoFutura() {
				this.showModal = true;
				this.texto_btn_finalizar_processo = "Finalizar Preparação";
			},
			FinalizarDocumento() {

				if (!this.$store.state.processo.peticoes) {
					alert("Nenhum arquivo adicionado a petição.");
					return;
				}

				this.showModal = true;
				this.texto_btn_finalizar_processo = "Finalizar";
			},
			GravarProcesso() {
				if (this.texto_btn_finalizar_processo = "Finalizar") { //Quando o usuário clicar em finalizar grava a data do protocolo e com essa informação é efetivado o processo. Se só salvar para distribuição futura não grava a data do protocolo
					try {
						let processoId = this.$store.state.processo.id;
						const response = axios.post(this.BASE_URL + 'processo_protocolar', {
							processoId: processoId
						});

						alert("Processo nº " + this.$store.state.processo.codigo_processo + " protocolado com sucesso!");

					} catch (error) {
						console.error('Erro ao efetivar o protocolo.', error);
					}
				}

				window.location.href = this.BASE_URL;
			},
			Cancelar() {
				if (confirm("Deseja realmente cancelar o cadastro deste processo?")) {
					window.location.href = this.BASE_URL + "home";
				}
			},
			IncluirOutros() {
				this.incluir_outros_advogados = !this.incluir_outros_advogados;
			},
			/* Funções do passos 1 */
			CarregarDados(dados_carregar) {
				axios.get(this.BASE_URL + 'buscar/dados_iniciais/' + dados_carregar)
					.then(response => {
						if (dados_carregar == 'cidades') {
							this.cidades = response.data;
						}
						else if (dados_carregar == 'ritos') {
							this.ritos = response.data;
						}
						else if (dados_carregar == 'areas') {
							this.areas = response.data;
						}
						else if (dados_carregar == 'classes') {
							this.classes_processuais = response.data;
						}

					})
					.catch(error => {
						console.error('Erro ao buscar informações da ' + dados_carregar + ':', error);
					});
			},

			CarregarCidades() {
				this.CarregarDados('cidades');
			},
			CarregarRitos() {
				this.CarregarDados('ritos');
			},
			CarregarAreas() {
				this.CarregarDados('areas');
			},
			CarregarClasses() {
				this.CarregarDados('classes');
			},
			formatarValorMonetario() {
				let valor = this.valor_causa.replace(/\D/g, ''); // Remove tudo o que não é dígito
				valor = (valor / 100).toFixed(2) + ''; // Converte para decimal
				valor = valor.replace(".", ",");
				valor = valor.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'); // Adiciona os pontos milhares

				this.valor_causa = valor; // Atualiza o valor formatado de volta ao modelo

				this.calculaPrevisaoCustas();
			},
			calculaPrevisaoCustas() {
				let valor = this.valor_causa.replace(/\D/g, ''); // Remove tudo o que não é dígito
				valor = (valor / 100).toFixed(2) + ''; // Converte para decimal

				if (isNaN(valor)) {
					return 0; // Retorna 0 ou oculta a mensagem se não for um número ou for menor ou igual a zero
				}

				let calculo = valor * 0.025; // Calcula 2.5% do valor da causa

				if (valor <= 0) {
					calculo = 0;
				}
				else if (calculo < 253.90) {
					calculo = 253.90;
				}

				//calculo = calculo.toString().replace(".", ",");
				//calculo = calculo.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

				//this.previsao_custas = calculo;
				this.previsao_custas = new Intl.NumberFormat('pt-BR', {
					style: 'currency',
					currency: 'BRL',
				}).format(calculo);
			},
			buscarUsuarios() {
				if (this.login_outro_usuario.length > 2) { // Evita busca com poucos caracteres
					axios.get(this.BASE_URL + 'usuarios/buscar', { params: { query: this.login_outro_usuario } })
						.then(response => {
							this.usuarios_pesquisados = response.data;
						})
						.catch(error => {
							console.error("Erro ao buscar usuários:", error);
						});
				} else {
					this.usuarios_pesquisados = [];
				}
			},
			selecionarUsuario(usuario) {
				const usuarioJaAdicionado = this.login_outros_usuarios.some(u => u.id === usuario.id); // Verifica se o usuário já foi adicionado ao array
				if (!usuarioJaAdicionado) {
					// Se o usuário não estiver no array, adiciona-o
					this.login_outros_usuarios.push({ 'name': usuario.name, 'id': usuario.id, 'email': usuario.email });
				}

				this.usuarios_pesquisados = [];
				this.login_outro_usuario = '';
			},
			excluirItem(itemId) {
				const index = this.login_outros_usuarios.findIndex(usuario => usuario.id === itemId);

				if (index !== -1) {
					this.login_outros_usuarios.splice(index, 1);
				}
			},
			/* Fim das funções do passos 1 */
		},
		mounted() {
			this.CarregarCidades();
			this.CarregarRitos();
			this.CarregarAreas();
			this.CarregarClasses();
			this.ConfigurarIA();
		},
		watch: {
			sugestoesIA(newVal) {
				if (newVal.length > 0) {
					this.mostrarSugestao(0);
				}
			},
		}
	};
</script>

<style scoped>
	@import url("../../../css/ia.css");

	h1 {
		font-size: 26px;
	}

	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
		;
	}


	.custom-dropdown {
		height: 35px;
		/* Diminui a altura do campo select */
		position: relative;
		background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%22292.4%22%20height%3D%22292.4%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20viewBox%3D%220%200%20292.4%20292.4%22%20enable-background%3D%22new%200%200%20292.4%20292.4%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cg%3E%0A%3Cpath%20d%3D%22M287%2069.201a9.7%209.7%200%200%201%201.7%206.813l-4%204%20c-0.092%200.093-0.203%200.166-0.3%200.26l-127%20127c-1.8%201.801-4.501%202.701-7.1%202.701s-5.3-0.9-7.1-2.7l-127-127c-0.1-0.094-0.2-0.167-0.3-0.26l-4-4c-1.8-1.801-1.8-4.701%200-6.5%200.9-0.899%202.3-1.5%203.6-1.5h254.8c1.3%200%202.7%200.601%203.6%201.5z%22%20fill%3D%22%23000000%22/%3E%0A%3C/g%3E%0A%3C/svg%3E');
		background-position: right 0.75rem center;
		background-size: 10px 10px;
		background-repeat: no-repeat;
	}

	/* Estilo para manter o ícone de seta mesmo com o select aberto */
	.custom-dropdown:focus {
		background-image: none;
		outline: none;
	}

	/* Estilo para reverter o ícone de seta padrão */
	.custom-dropdown::-ms-expand {
		display: none;
	}

	.modal-backdrop {
		position: fixed !important;
		top: 0 !important;
		left: 0 !important;
		width: 100vw !important;
		height: 100vh !important;
		background-color: rgba(0, 0, 0, 0.5) !important;
		z-index: 1040 !important;
	}

	.modal-largura-customizada {
		max-width: 1000px;
		/* Define a largura máxima do modal */
		width: 100%;
		/* Garante que o modal se ajuste à largura definida até o máximo permitido */
	}


	/* Switch do primeiro passo da IA */
	.toggle-switch {
		padding: 0;
		border: none;
		background: none;
		cursor: pointer;
		outline: none;
	}

	/* estado desabilitado */
	.toggle-switch--disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}

	/* trilho */
	.toggle-switch__track {
		position: relative;
		display: inline-block;
		width: 40px;
		height: 22px;
		border-radius: 999px;
		background-color: #d3d6db;
		/* cinza claro - desligado */
		box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
		transition: background-color 0.2s ease;
	}

	/* bolinha */
	.toggle-switch__thumb {
		position: absolute;
		top: 2px;
		left: 2px;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background-color: #ffffff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
		transition: transform 0.2s ease;
	}

	/* ligado */
	.toggle-switch--on .toggle-switch__track {
		background-color: #4cd964;
		/* verde estilo iOS */
	}

	.toggle-switch--on .toggle-switch__thumb {
		transform: translateX(18px);
	}

</style>
